import { safeGetSession } from './supabase';
import { getAccessToken } from './authStore';
import type { CheckoutType } from '../utils/checkoutStorage';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL as string | undefined;

export interface CheckoutMetaContext {
  purchaseEventId: string;
  fbp?: string;
  fbc?: string;
  oppref?: string;
  obref?: string;
  billingType: CheckoutType;
  marketingConsent: boolean;
  eventSourceUrl?: string;
}

export interface MetaServerEventPayload {
  eventName: 'CompleteRegistration' | 'InitiateCheckout';
  eventId: string;
  eventSourceUrl?: string;
  fbp?: string;
  fbc?: string;
  marketingConsent: boolean;
  customData?: Record<string, string | number | boolean>;
}

export interface OpenAIServerEventPayload {
  eventType: 'registration_completed' | 'checkout_started';
  eventId: string;
  eventSourceUrl?: string;
  oppref?: string;
  obref?: string;
  marketingConsent: boolean;
  data?: Record<string, unknown>;
}

async function getJwtOrThrow(): Promise<string> {
  const token =
    getAccessToken() ||
    (await safeGetSession(4000)).data.session?.access_token ||
    undefined;
  if (!token) {
    throw new Error('AUTH_REQUIRED');
  }
  return token;
}

async function postAdsEvent(body: Record<string, unknown>): Promise<void> {
  if (!apiBaseUrl) {
    return;
  }

  try {
    const token = await getJwtOrThrow();
    const res = await fetch(`${apiBaseUrl}/ads/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      console.warn('Ads CAPI relay failed:', res.status, text);
    }
  } catch (error) {
    console.warn('Ads CAPI relay error:', error);
  }
}

export const metaEventsService = {
  async sendEvent(payload: MetaServerEventPayload): Promise<void> {
    if (!payload.marketingConsent) {
      return;
    }
    await postAdsEvent({ provider: 'meta', ...payload });
  },
};

export const openaiEventsService = {
  async sendEvent(payload: OpenAIServerEventPayload): Promise<void> {
    if (!payload.marketingConsent) {
      return;
    }
    await postAdsEvent({ provider: 'openai', ...payload });
  },
};
